<template>
  <div class="wrapper-jexcel" :class="{ readOnly }">
    <div id="spreadsheet" ref="spreadsheet"></div>
    <v-tooltip left v-if="!readOnly">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click="spreadsheet.insertRow()"
          color="primary"
          app
          fab
          absolute
          bottom
          right
          x-small
        >
          <v-icon x-small dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.financial.cashflow.new.meta.add }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import jspreadsheet from 'jexcel' // eslint-disable-line no-unused-vars
import 'jexcel/dist/jexcel.css' // eslint-disable-line no-unused-vars

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    category: {
      type: Number,
      default: 1
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mirror: {
      get () {
        let value = this.value.map(met => {
          if (this.category === 5) {
            return [
              met[0],
              met[1],
              met[2],
              `#${met[3].id} - ${met[3].title}`,
              met[5],
              met[6],
            ]
          }
          return met
        })
        return value
      },
      set (newVal) {
        this.$emit('changed', newVal)
      }
    },
    columns () {
      this.category
      switch (this.category) {
        case 1:
          return [
            {
              type: 'autocomplete',
              title: 'Profissional',
              width: '194px',
              source: [ ...this.get_data.employees ]
            },
            { type: 'text', title: 'Título', width: '255px' },
            {
              type: 'numeric',
              title: 'Total',
              width: '120px',
              mask: 'R$ #.##,00',
              decimal: ','
            }
          ]
        case 2:
          return [
            {
              type: 'autocomplete',
              title: 'Conta',
              width: '194px',
              source: ((this.get_data || {}).financial.periodicals || [])
                .filter(per => per.type === 2)
                .map(per => {
                  return {
                    id: per.id,
                    name: per.title
                  }
                })
            },
            { type: 'text', title: 'Título', width: '155px' },
            { type: 'calendar', title: 'Referência', width: '100px' },
            {
              type: 'numeric',
              title: 'Total',
              width: '120px',
              mask: 'R$ #.##,00',
              decimal: ','
            }
          ]
        case 3:
          return [
            {
              type: 'autocomplete',
              title: 'Produto',
              width: '174px',
              source: (this.get_data.catalog || [])
                .filter(item => item.catalog === 'items')
                .map(item => {
                  return {
                    id: item.id,
                    name: item.title
                  }
                })
            },
            { type: 'text', title: 'Título', width: '245px' },
            { type: 'numeric', title: 'Qty', width: '30px' },
            {
              type: 'numeric',
              title: 'Total',
              width: '120px',
              mask: 'R$ #.##,00',
              decimal: ','
            }
          ]
        case 4:
          return [
            { type: 'text', title: 'Título', width: '400px' },
            { type: 'numeric', title: 'Qty', width: '35px' },
            {
              type: 'numeric',
              title: 'Total',
              width: '120px',
              mask: 'R$ #.##,00',
              decimal: ','
            }
          ]
        case 5:
          /* return [
            {
              type: 'autocomplete',
              title: 'Referência',
              width: '450px',
              source: ((this.get_data || {}).financial.comissions || [])
                .map(co => {
                  let employee = this.get_data.employees.find(emp => emp.id === co.employee),
                      service = co.service || {}
                  return {
                    id: co.id,
                    name: `${employee.name} - #${service.id} ${service.title} (x${service.qty}) - ${this.formatCurrency(service.price)} - ${this.formatDate(co.datetime, false)}`
                  }
                })
            },
            /* { type: 'calendar', title: 'Data', width: '100px' },
            { type: 'text', title: 'Título', width: '100px' },
            { type: 'numeric', title: '%', width: '30px' }, 
            {
              type: 'numeric',
              title: 'Total',
              width: '120px',
              mask: 'R$ #.##,00',
              decimal: ','
            }
          ] */
          return [
            { type: 'numeric', title: 'ID', width: '50px' },
            { type: 'calendar', title: 'Data', width: '100px' },
            {
              type: 'autocomplete',
              title: 'Profissional',
              width: '140px',
              source: [ ...this.get_data.employees ]
            },
            { type: 'text', title: 'Serviço', width: '140px' },
            { type: 'numeric', title: '%', width: '30px' },
            {
              type: 'numeric',
              title: 'Total',
              width: '120px',
              mask: 'R$ #.##,00',
              decimal: ','
            }
          ]
      }
      return false
    },
    jExcelOptions () {
      this.mirror
      this.columns
      return {
        data: this.mirror,
        editable: !this.readOnly,
        allowInsertRow: !this.readOnly,
        allowManualInsertRow: !this.readOnly,
        allowDeleteRow: !this.readOnly,
        columns: this.columns,
        text: this.lang.utils.jexcel,
        // eslint-disable-next-line no-unused-vars
        onchange: function (instance, cell, c, r, value) {
          // console.log('onchange', { instance, cell, c, r, value })
        }
      };
    }
  },
  methods: {
    insertRowc() {
      console.log(this);
      // this.spreadsheet.insertRow();
    }
  },
  mounted () {
    const spreadsheet = jspreadsheet(this.$refs['spreadsheet'], this.jExcelOptions)
    spreadsheet.hideIndex()
    // Object.assign(this, spreadsheet)
    Object.assign(this, { spreadsheet })
  }
}
</script>

<style lang="scss">
#app .wrapper-jexcel {
  position: relative;
  &.readOnly {
    pointer-events: none !important;
  }
}
.jexcel {
  #app & {
    border-radius: 7px;
    thead {
      td {
        border: none !important;
      }
    }
    tbody {
      tr {
        height: 24px;
      }
    }
  }

  #app.theme--light & {
    background: rgba(237, 231, 226,0.7);
    border: 1px solid #ddd;
    thead {
      td {
        background-color: rgba(0,0,0,0.03);
        &.selected {
          background-color: rgba(0, 0, 0, 0.07) !important;
        }
      }
    }
    tbody {
      td {
        border-top: 1px solid #ddd !important;
        border-left: 1px solid transparent !important;
        border-right: 1px solid transparent !important;
        &:not(:last-of-type) {
          border-right: 1px solid #ddd !important;
        }
      }
    }
  }
}
</style>